import { FCC } from "@/types/common";
import { Grid, Stack, styled, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { black } from "@/theme/colors";
import { convertDateFromIsoString } from "@/features/company/utiles/datetime";

type TCompanyTitle = {
  managementNumber?: string | null | undefined;
  title?: string | null | undefined;
  isArchive?: boolean | null | undefined;
  createdAt?: string | null | undefined;
  updatedAt?: string | null | undefined;
};

export const CompanyTitle: FCC<TCompanyTitle> = ({ managementNumber, title, isArchive, createdAt, updatedAt }) => {
  const { companyId } = useParams();
  const titleFinal = title ? title : "新規企業登録";

  return (
    <TitleContainer>
      <Stack>
        <Stack direction="row" alignContent="center" alignItems="center" gap={2} mb={4}>
          <Typography variant="head20Bold">{titleFinal}</Typography>
        </Stack>
        {companyId && (
          <Grid container gap={2}>
            <Typography variant="body14Light" color={black[70]}>
              企業管理番号：{managementNumber ?? "-"}
            </Typography>
            {createdAt && (
              <Typography variant="body14Light" color={black[70]}>
                登録日時：{convertDateFromIsoString(createdAt) ?? "-"}
              </Typography>
            )}
            {updatedAt && (
              <Typography variant="body14Light" color={black[70]}>
                更新日時：{convertDateFromIsoString(updatedAt) ?? "-"}
              </Typography>
            )}
          </Grid>
        )}
      </Stack>
    </TitleContainer>
  );
};

const TitleContainer = styled(Stack)`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: self-start;
  margin-bottom: 8px;
`;
